import { render, staticRenderFns } from "./ContactNotificationsPopup.vue?vue&type=template&id=11e017e5&"
import script from "./ContactNotificationsPopup.vue?vue&type=script&lang=js&"
export * from "./ContactNotificationsPopup.vue?vue&type=script&lang=js&"
import style0 from "./ContactNotificationsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports